export enum MAGIC8BALL_OPENED_FROM {
    GAME = 'game',
    MENU = 'menu'
};